var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarSelectedHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0961 6.60717L8.84609 0.710292C8.84304 0.707627 8.84017 0.704756 8.8375 0.701699C8.60739 0.492428 8.30752 0.376465 7.99648 0.376465C7.68545 0.376465 7.38558 0.492428 7.15547 0.701699L7.14688 0.710292L0.903906 6.60717C0.776561 6.72427 0.674909 6.86653 0.605384 7.02494C0.535859 7.18336 0.499974 7.35448 0.5 7.52748V14.7501C0.5 15.0817 0.631696 15.3996 0.866116 15.634C1.10054 15.8684 1.41848 16.0001 1.75 16.0001H5.5C5.83152 16.0001 6.14946 15.8684 6.38388 15.634C6.6183 15.3996 6.75 15.0817 6.75 14.7501V11.0001H9.25V14.7501C9.25 15.0817 9.3817 15.3996 9.61612 15.634C9.85054 15.8684 10.1685 16.0001 10.5 16.0001H14.25C14.5815 16.0001 14.8995 15.8684 15.1339 15.634C15.3683 15.3996 15.5 15.0817 15.5 14.7501V7.52748C15.5 7.35448 15.4641 7.18336 15.3946 7.02494C15.3251 6.86653 15.2234 6.72427 15.0961 6.60717ZM14.25 14.7501H10.5V11.0001C10.5 10.6686 10.3683 10.3507 10.1339 10.1163C9.89946 9.88183 9.58152 9.75014 9.25 9.75014H6.75C6.41848 9.75014 6.10054 9.88183 5.86612 10.1163C5.6317 10.3507 5.5 10.6686 5.5 11.0001V14.7501H1.75V7.52748L1.75859 7.51967L8 1.62514L14.2422 7.51811L14.2508 7.52592L14.25 14.7501Z",
    fill: "#6B5CE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarSelectedHome);
export default __webpack_public_path__ + "static/media/dar_selected_home.5248584d87843d87938ca05ee8ab51ea.svg";
export { ForwardRef as ReactComponent };